import React from 'react';
import { FlexGrid } from '@gasbuddy/react-components';
import StationFuelPriceCard from './station-fuel-price';
import StationFuelTypesCard from './station-fuel-types';
import StationAmenitiesCard from './station-amenities';
import StationHoursCard from './station-hours/card';
import StationStatusCard from './station-status/card';
import StationBrandsCard from './station-brands';
import StationInformationCard from './station-information/card';

export default function StationProfileTab() {
  return (
    <div>
      <StationInformationCard />
      <FlexGrid container>
        <FlexGrid.Column mobile={12} tablet={6}>
          <StationStatusCard />
        </FlexGrid.Column>
        <FlexGrid.Column mobile={12} tablet={6}>
          <StationBrandsCard />
        </FlexGrid.Column>
      </FlexGrid>
      <StationFuelPriceCard />
      <StationFuelTypesCard />
      <StationAmenitiesCard />
      <StationHoursCard />
    </div>
  );
}
